import "~/css/profile.css";
import ALogin from "./Login.vue";
import TradiqueLogin from "./TradiqueLogin.vue";
import { UnAuthorizedLayout, TradiqueLayout } from "~/components";

new Vue({
  delimiters: ["[[", "]]"],
  el: "#login_layout",
  components: {
    ALogin,
    TradiqueLogin,
    UnAuthorizedLayout,
    TradiqueLayout,
  },
});
